import { getRequest, postRequest } from '../request/request.service';
import { BusinessHours, BusinessHoursParams, BusinessHoursPayload } from './business-hours.types';

export function getBusinessHours(params: BusinessHoursParams) {
  return getRequest<BusinessHours>(`business_hours`, {
    params,
  });
}

export function updateBusinessHours(payload: BusinessHoursPayload, params: BusinessHoursParams) {
  return postRequest<BusinessHours>(`business_hours`, {
    params,
    data: payload,
  });
}
